import { useQuery, useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../../../api/hooks/useAPI";
import {
  dashboardKeys,
  platformUsersKeys,
} from "../../../../../../api/queryKeys";
import FavoritesButton from "../../../../../../components/FavoriteButton";

const ControlFavoritesButton = ({ controlId }) => {
  const { toggleFavoriteControl, getFavoriteControls, trackEvent } = useAPI();
  const queryClient = useQueryClient();
  const { data: fetchedFavoriteControls, isLoading: isLoadingFavorites } =
    useQuery({
      queryKey: platformUsersKeys.favoriteControls(),
      queryFn: getFavoriteControls,
      select: (data) => data.data,
    });
  const isFavorite = fetchedFavoriteControls?.includes(controlId.toString());
  const isLoading = isLoadingFavorites;

  const handleToggleFavorite = async () => {
    trackEvent(
      isFavorite
        ? `User removed favorite control ${controlId}`
        : `User added favorite control ${controlId}`
    );

    await toggleFavoriteControl(controlId, !isFavorite).then(() => {
      queryClient.invalidateQueries({
        queryKey: platformUsersKeys.favoriteControls(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardKeys.all,
      });
    });
  };

  return (
    <FavoritesButton
      handleToggleFavorite={handleToggleFavorite}
      isFavorite={isFavorite}
      isLoading={isLoading}
    />
  );
};

export default ControlFavoritesButton;
